<template>
  <BExpansionTableDirections
    :list="list"
    :pagination="pagination"
    :ordering="filters.ordering"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"

    :title="pageTitle"
    :creatable="creatable"
    :button-text="pageTitleCreate"

    @change:sort="onChangeSort"
    @change:pagination="onChangePagination"
    @change:sortable-positions="onUpdatePositions"

    @action:create="onActionCreate"
    @action:edit="onActionEdit"
    @action:view="onActionView"
    @action:delete="onActionDelete"
  />
</template>

<script>
import { lkRoadmapPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { RoadmapDirectionModel as Model } from './Model'
import { roadmapDirectionsStoreModule as StoreModule } from './store'
import { createRoadmapDirectionsModal } from './utils'

import BExpansionTableDirections from './components/BExpansionTableDirections.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewRoadmapDirectionsList',
  components: {
    BExpansionTableDirections,
  },
  mixins: [
    listMixin,
  ],
  props: {
    roadmapId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      disabledPaginationQuery: true,
      defaultParams: {
        roadmap_id: this.roadmapId,
      },
    }
  },
  computed: {
    creatable() {
      return this.$access(Permissions.create)
    },
  },
  /** @type { List } */
  methods: {
    onActionCreate() {
      const readonly = false
      this.onOpenModal(null, readonly)
    },
    onActionEdit(data) {
      const readonly = false
      this.onOpenModal(data, readonly)
    },
    onActionView(data) {
      const readonly = true
      this.onOpenModal(data, readonly)
    },
    async onActionDelete(data) {
      await this.onDeleteWithRefresh(data, this.defaultParams)
    },
    async onOpenModal(data, readonly) {
      const propsData = await this.getPropsData(data, readonly)
      const modal = await createRoadmapDirectionsModal(this, propsData)
      await modal.open()
      this.onGetData(this.filters)
    },
    getPropsData(data, readonly = false) {
      const action = (payload) => {
        const options = {
          ...this.defaultParams,
          payload: { ...payload, ...this.defaultParams },
          id: payload.id,
        }

        const promise = payload.id
          ? this.update(options)
          : this.create(options)

        return promise
      }

      const propsData = {
        data,
        readonly,
        actionSave: action,
        actionDelete: this.onActionDelete,
        successText: data ? Model.response_success.update : Model.response_success.create,
        errorText: data ? Model.response_error.update : Model.response_error.create,
        ...this.defaultParams,
      }

      return propsData
    },
  },
}
</script>
